const defaultState = { open: false };

export default (state = defaultState, action) => {
    const { type } = action;

    switch (type) {
        case "openMenu/toggle":
            return { ...state, open: !state.open };
        case "openMenu/clear":
        case "REDUX/CLEAR":
            return { ...defaultState };
        default:
            return state;
    }
};